import { useQuery } from '@apollo/client';
import get from 'lodash.get';
import { gql } from 'graphql-tag';

export const ATTACHMENT_INFO_QUERY = gql`
  query attachmentInfo($input: PRAA_AttachmentsInfoInput!) {
    attachmentInfo(input: $input) {
      id
      processed
      notifyUser
    }
  }
`;

const useGetAttachmentInfo = ({ binaryObjectUri }) => {
  const { data } = useQuery(ATTACHMENT_INFO_QUERY, {
    variables: {
      input: {
        binaryObjectUris: [binaryObjectUri]
      }
    },
    fetchPolicy: 'network-only'
  });

  const attachmentsInfo = get(data, 'attachmentInfo') || [];
  const attachment = attachmentsInfo.length !== 0 ? attachmentsInfo[0] : null;

  return {
    processed: attachment?.processed,
    notifyUser: attachment?.notifyUser
  };
};

export default useGetAttachmentInfo;
